<div id="mockups">
    <a
        checkoutCy="dev-configurator-enable-mocks"
        (click)="toggleMock()"
        class="button is-small"
        [ngClass]="useMock ? 'has-text-white has-background-warning' : 'is-primary'"
    >
        {{ mockLabel }} les mocks
    </a>
    @if (useMock) {
        <div>
            @for (step of steps; track step; let index = $index) {
                @if (step.isActive) {
                    @for (stepMock of step.stepMocks; track stepMock) {
                        <div class="columns is-multiline is-justified-center is-aligned-center">
                            <div class="column is-narrow has-text-centered">
                                <div class="control">
                                    <div class="tags">
                                        <span class="tag is-dark">URL API</span>
                                        <span class="tag is-info">{{ stepMock.url }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-narrow">
                                <div class="buttons">
                                    @for (mock of stepMock?.mocks; track mock) {
                                        <a
                                            (click)="mockData(stepMock.url, mock)"
                                            class="button is-small is-primary"
                                            [ngClass]="
                                                this.mockedKey[stepMock.url] === mock.key &&
                                                'has-background-info-fade has-text-secondary-invert'
                                            "
                                        >
                                            {{ mock.label }}
                                        </a>
                                    }
                                    @if (stepMock.mocks?.length > 0) {
                                        <a
                                            (click)="mockData(stepMock.url, emptyMock)"
                                            class="button is-small is-primary"
                                            [ngClass]="
                                                this.mockedKey[stepMock.url] === emptyMock.key &&
                                                'has-background-info-fade has-text-secondary-invert'
                                            "
                                        >
                                            {{ emptyMock.label }}
                                        </a>
                                    }
                                    <span
                                        class="icon is-medium is-circled has-text-tertiary-invert"
                                        [ngClass]="
                                            multiMockModes[stepMock.url]
                                                ? 'has-background-success'
                                                : 'has-background-main'
                                        "
                                        (click)="toggleMultiMockMode(stepMock.url)"
                                    >
                                        <i class="tri-plus-circle"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="column is-12">
                                @if (appService.mocks[stepMock.url] && appService.mocks[stepMock.url].length > 1) {
                                    Les mocks seront joués dans cet ordre :
                                    @for (
                                        choosenMock of appService.mocks[stepMock.url];
                                        track choosenMock;
                                        let index = $index
                                    ) {
                                        <span>
                                            {{ choosenMock.label
                                            }}{{
                                                index !== appService.mocks[stepMock.url].length - 1
                                                    ? ' - '
                                                    : ' (sera toujours joué une fois les autres dépilés)'
                                            }}
                                        </span>
                                    }
                                }
                            </div>
                        </div>
                    }
                }
            }
        </div>
    }
</div>
